[
  {
    "slug": "freeui-button",
    "group": "Controls"
  },
  {
    "slug": "freeui-slider",
    "group": "Controls"
  },
  {
    "slug": "freeui-menu",
    "group": "Controls"
  },
  {
    "slug": "freeui-knob",
    "group": "Controls"
  },
  {
    "slug": "freeui-action-bar",
    "group": "Bars"
  },
  {
    "slug": "freeui-sub-bar",
    "group": "Bars"
  },
  {
    "slug": "freeui-toolbar",
    "group": "Bars"
  },
  {
    "slug": "freeui-titlebar",
    "group": "Panels"
  },
  {
    "slug": "freeui-inspector",
    "group": "Panels"
  },
  {
    "slug": "freeui-disclosure",
    "group": "Panels"
  },
  {
    "slug": "freeui-statusbar",
    "group": "Panels"
  },
  {
    "slug": "button",
    "group": "Forms & inputs"
  },
  {
    "slug": "button-group",
    "group": "Forms & inputs"
  },
  {
    "slug": "calendar",
    "group": "Forms & inputs"
  },
  {
    "slug": "checkbox",
    "group": "Forms & inputs"
  },
  {
    "slug": "combobox",
    "group": "Forms & inputs"
  },
  {
    "slug": "field",
    "group": "Forms & inputs"
  },
  {
    "slug": "form",
    "group": "Forms & inputs"
  },
  {
    "slug": "input",
    "group": "Forms & inputs"
  },
  {
    "slug": "label",
    "group": "Forms & inputs"
  },
  {
    "slug": "input-otp",
    "group": "Forms & inputs"
  },
  {
    "slug": "input-group",
    "group": "Forms & inputs"
  },
  {
    "slug": "select",
    "group": "Forms & inputs"
  },
  {
    "slug": "radio-group",
    "group": "Forms & inputs"
  },
  {
    "slug": "slider",
    "group": "Forms & inputs"
  },
  {
    "slug": "switch",
    "group": "Forms & inputs"
  },
  {
    "slug": "native-select",
    "group": "Forms & inputs"
  },
  {
    "slug": "toggle",
    "group": "Forms & inputs"
  },
  {
    "slug": "toggle-group",
    "group": "Forms & inputs"
  },
  {
    "slug": "textarea",
    "group": "Forms & inputs"
  },
  {
    "slug": "date-picker",
    "group": "Forms & inputs"
  },
  {
    "slug": "questionnaire",
    "group": "Forms & inputs"
  },
  {
    "slug": "breadcrumb",
    "group": "Layout & navigation"
  },
  {
    "slug": "aspect-ratio",
    "group": "Layout & navigation"
  },
  {
    "slug": "accordion",
    "group": "Layout & navigation"
  },
  {
    "slug": "collapsible",
    "group": "Layout & navigation"
  },
  {
    "slug": "card",
    "group": "Layout & navigation"
  },
  {
    "slug": "navigation-menu",
    "group": "Layout & navigation"
  },
  {
    "slug": "item",
    "group": "Layout & navigation"
  },
  {
    "slug": "pagination",
    "group": "Layout & navigation"
  },
  {
    "slug": "scroll-area",
    "group": "Layout & navigation"
  },
  {
    "slug": "resizable",
    "group": "Layout & navigation"
  },
  {
    "slug": "separator",
    "group": "Layout & navigation"
  },
  {
    "slug": "sidebar",
    "group": "Layout & navigation"
  },
  {
    "slug": "tabs",
    "group": "Layout & navigation"
  },
  {
    "slug": "kbd",
    "group": "Layout & navigation"
  },
  {
    "slug": "direction",
    "group": "Layout & navigation"
  },
  {
    "slug": "alert-dialog",
    "group": "Overlays"
  },
  {
    "slug": "dialog",
    "group": "Overlays"
  },
  {
    "slug": "command",
    "group": "Overlays"
  },
  {
    "slug": "drawer",
    "group": "Overlays"
  },
  {
    "slug": "context-menu",
    "group": "Overlays"
  },
  {
    "slug": "dropdown-menu",
    "group": "Overlays"
  },
  {
    "slug": "hover-card",
    "group": "Overlays"
  },
  {
    "slug": "menubar",
    "group": "Overlays"
  },
  {
    "slug": "popover",
    "group": "Overlays"
  },
  {
    "slug": "sheet",
    "group": "Overlays"
  },
  {
    "slug": "tooltip",
    "group": "Overlays"
  },
  {
    "slug": "toast",
    "group": "Data & feedback"
  },
  {
    "slug": "avatar",
    "group": "Data & feedback"
  },
  {
    "slug": "alert",
    "group": "Data & feedback"
  },
  {
    "slug": "badge",
    "group": "Data & feedback"
  },
  {
    "slug": "carousel",
    "group": "Data & feedback"
  },
  {
    "slug": "chart",
    "group": "Data & feedback"
  },
  {
    "slug": "empty",
    "group": "Data & feedback"
  },
  {
    "slug": "progress",
    "group": "Data & feedback"
  },
  {
    "slug": "skeleton",
    "group": "Data & feedback"
  },
  {
    "slug": "spinner",
    "group": "Data & feedback"
  },
  {
    "slug": "table",
    "group": "Data & feedback"
  },
  {
    "slug": "sonner",
    "group": "Data & feedback"
  },
  {
    "slug": "data-table",
    "group": "Data & feedback"
  },
  {
    "slug": "typography",
    "group": "Data & feedback"
  },
  {
    "slug": "bubble",
    "group": "Conversation"
  },
  {
    "slug": "attachment",
    "group": "Conversation"
  },
  {
    "slug": "message-scroller",
    "group": "Conversation"
  },
  {
    "slug": "marker",
    "group": "Conversation"
  },
  {
    "slug": "message",
    "group": "Conversation"
  }
]
